export const MIME_TYPE_MAP:Record<string, string> = {
    mp4: 'video/mp4',
    webp: 'image/webp',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    avi: 'video/x-msvideo',
    mov: 'video/quicktime',
};
